import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '@/layout'

/* 系统菜单 */
// import system from './system/system'
import permission from './system/permission'
import tencentAD from './tencentAD/index.js'
import massiveAdvertisingAD from './massiveAdvertisingAD/index.js'
import dxj from './dxjApi/index.js'
import adx from './adx/index.js'
import tiktok from './tiktok/index'

// import extension from './system/extension'
// import abc from './abc/abc'
// import customer from './customer/index.js'
import nove from './nove/index.js'
import accountManagement from './accountManagement/index.js'
// import reportForm from './reportForm/index.js'
// import dataReport from './dataReport/index'
// import crowdManagement from './crowdManagement/index'
// import materialCenter from './materialCenter/index'
import providerAccountManagement from './providerAccountManagement/index'
import monitoringManagement from './monitoringManagement/index.js'
import merchantMaintenanceNumber from './merchantMaintenanceNumber/index.js'
import releaseGroup from './releaseGroup/index.js'
import copyReleaseGroup from './copyReleaseGroup/index.js'
import copyiaarouter from './copyiaarouter/index.js'
import copyiaarouterNative from './copyiaarouterNative/index.js'
import TKreleaseGroup from './TKreleaseGroup/index.js'
import sourceMaterial from './sourceMaterial/index.js'
import newLauchGroup from './newLaunchGroup/index.js'
import novelReporthing from './novelReporthing/index.js'
import ListnewLauchGroup from './ListnewLauchGroup/index.js'
import hugeAdvertGroup from './hugeAdvertGroup/index.js'
import materialReport from './materialReport/index.js'
import shortPlayReport from './shortPlayReport/index.js'
import retransmissionStrategy from './retransmissionStrategy/index.js' // 回传策略
import taobaoLink from './taobaoLink/index.js' // 淘宝链接
import crossborderCommerce from './crossborderCommerce/index.js' // 跨境电商
import Infrastructuredata from './Infrastructuredata/index.js' // 基建数据报表
import applicationmanagement from './applicationmanagement/index.js' // 应用管理
import approved from './approved/index'
import adMonitor from './adMonitor/index.js'
import baiduAD from '@/router/baiduAD'
import oceanNovelReport from '@/router/oceanNovelReport/index.js'
import iQiyi from './iQiyi/index.js' // 爱奇艺

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export const constantRoutes = [
  {
    path: '/redirect',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/redirect/:path(.*)',
        component: () => import('@/views/redirect/index')
      }
    ]
  },
  {
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true
  },
  {
    path: '/auth-redirect',
    component: () => import('@/views/login/auth-redirect'),
    hidden: true
  },
  {
    path: '/404',
    component: () => import('@/views/error-page/404'),
    hidden: true
  },
  {
    path: '/401',
    component: () => import('@/views/error-page/401'),
    hidden: true
  },
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard/index',
    children: [
      {
        path: '/dashboard/index',
        component: () => import('@/views/dashboard/index.vue'), /* @/views/dataReport/effectData.vue */
        name: 'EffectData',
        meta: { title: 'dashboard', icon: 'dashboard', affix: true }
      }
    ],
    hidden: true
  },
  {
    path: '/profile',
    component: Layout,
    redirect: '/profile/index',
    hidden: true,
    children: [
      {
        path: 'index',
        component: () => import('@/views/profile/index'),
        name: 'Profile',
        meta: { title: 'profile', icon: 'user', noCache: true }
      }
    ]
  },
  {
    path: '/messageNotification',
    component: Layout,
    redirect: '/messageNotification/index',
    hidden: true,
    children: [
      {
        path: 'index',
        component: () => import('@/views/messageNotification/index'),
        name: 'messageNotification',
        meta: { title: '消息通知', icon: '', noCache: true }
      }
    ]
  },
  {
    path: '/dashboard',
    component: Layout,
    redirect: '/dashboard/index',
    hidden: true,
    children: [
      {
        path: 'index',
        component: () => import('@/views/dashboard/index.vue'),
        name: 'dashboard',
        meta: { title: '首页', noCache: true }
      }
    ]
  },

  /* {
    path: '/icon',
    component: Layout,
    children: [
      {
        path: 'index',
        component: () => import('@/views/icons/index'),
        name: 'Icons',
        meta: { title: 'icons', icon: 'icon', noCache: true }
      }
    ]
  }, */
  {
    path: '/DefaultLayout',
    redirect: '/DefaultLayout/index',
    component: Layout,
    children: [{
      path: 'index',
      component() {
        return import('@/layout/DefaultLayout.vue')
      }
    }]
  },

  {
    path: '/newNativePromotionPage',
    redirect: '/newNativePromotionPage/index',
    component: Layout,
    children: [{
      path: 'index',
      component() {
        return import('@/views/newNativePromotionPage/index.vue')
      }
    }]
  },

  {
    path: '/oldReleasePlan',
    redirect: '/oldReleasePlan/index',
    component: Layout,
    children: [{
      path: 'index',
      component() {
        return import('@/views/oldReleasePlan/index.vue')
      }
    }]
  }, {
    path: '/nativePAGE',
    redirect: '/nativePAGE/index',
    component: Layout,
    children: [{
      path: 'index',
      component() {
        return import('@/views/nativePAGE/index.vue')
      }
    }]
  }, {
    path: '/readTreasure',
    redirect: '/readTreasure/index',
    component: Layout,
    children: [{
      path: 'index',
      component() {
        return import('@/views/readTreasure/index.vue')
      }
    }]
  },
  {
    path: '/landingPage',
    redirect: '/landingPage/index',
    component: Layout,
    children: [{
      path: 'index',
      component() {
        return import('@/views/publicReadingTreasure/landingPage.vue')
      }
    }]
  },
  {
    path: '/planAccount',
    redirect: '/planAccount/index',
    component: Layout,
    children: [{
      path: 'index',
      component() {
        return import('@/views/publicPlan/planAccount.vue')
      }
    }]
  },
  {
    path: '/accountAdvertising',
    redirect: '/accountAdvertising/index',
    component: Layout,
    children: [{
      path: 'index',
      component() {
        return import('@/views/publicAdvertisingMP/accountAdvertising.vue')
      }
    }]
  },
  {
    path: '/newEdition',
    redirect: '/newEdition/index',
    component: Layout,
    children: [{
      path: 'index',
      component() {
        return import('@/views/newEdition/index.vue')
      }
    }]
  }
]

/**
 * asyncRoutes
 * the routes that need to be dynamically loaded based on user roles
 */
export const asyncRoutes = [
  // system,
  permission,
  // extension,
  // abc,
  // customer,
  tencentAD,
  baiduAD,
  massiveAdvertisingAD,
  tiktok,
  iQiyi,
  adx,
  dxj,
  crossborderCommerce,
  nove,
  accountManagement,
  // reportForm,
  // dataReport,
  // crowdManagement,
  // materialCenter,
  providerAccountManagement,
  monitoringManagement,
  merchantMaintenanceNumber,
  releaseGroup,
  copyReleaseGroup,
  copyiaarouter,
  copyiaarouterNative,
  TKreleaseGroup,
  oceanNovelReport,
  newLauchGroup,
  novelReporthing,
  hugeAdvertGroup,
  Infrastructuredata,
  applicationmanagement,
  materialReport,
  sourceMaterial,
  shortPlayReport,
  ListnewLauchGroup,
  adMonitor,
  retransmissionStrategy,
  approved,
  taobaoLink,
  // 404 page must be placed at the end !!!
  { path: '*', redirect: '/404', hidden: true }
]

const createRouter = () => new Router({
  // mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}
export default router
